var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "c-footer" },
    [
      _c("PageTop"),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-6" }, [
            _c("div", { staticClass: "c-footer__info" }, [
              _c("div", { staticClass: "c-footer__info-name" }, [
                _c("p", { staticClass: "title is-5" }, [
                  _vm._v(_vm._s(_vm.sitename))
                ])
              ]),
              _c(
                "div",
                { staticClass: "c-footer__info-address" },
                [_vm._t("default")],
                2
              )
            ])
          ]),
          _vm._m(0)
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-6" }, [
      _c("div", { staticClass: "c-footer__copy" }, [
        _vm._v("© BUKKYO UNIVERSITY All Rights Reserved.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }